/**
 * This component renders the news tab for a club page
 */

import React from "react";
import News from "../news/News";

const ClubNews = ({ clubData }) => {

  return (
    <News type="club" club={clubData.id} />
  );
};

export default ClubNews;
